import React from "react";
import { formatRelativeTime } from "../../utils/helpers";

const PostHeader = ({ user, createdAt }) => (
  <header className="wpc-header">
    <div
      className="wpc-avatar"
      style={{ background: user.avatarColor }}
      aria-hidden="true"
    >
      {user.name?.charAt(0).toUpperCase()}
    </div>
    <div className="wpc-header-info">
      <p className="wpc-username">{user.name}</p>
      <p className="wpc-timestamp">{formatRelativeTime(createdAt)}</p>
    </div>
  </header>
);

export default PostHeader;
